'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WixComponent2 = require('../../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _TextLinkLayout = require('../../BaseComponents/TextLinkLayout');

var _TextLinkLayout2 = _interopRequireDefault(_TextLinkLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseTextLink = function (_WixComponent) {
  _inherits(BaseTextLink, _WixComponent);

  function BaseTextLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BaseTextLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BaseTextLink.__proto__ || Object.getPrototypeOf(BaseTextLink)).call.apply(_ref, [this].concat(args))), _this), _this._handleOnClick = function (event) {
      if (!_this.props.link) {
        event.preventDefault();
      }

      _this.props.onClick(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BaseTextLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          ariaLabel = _props.ariaLabel,
          disabled = _props.disabled,
          link = _props.link,
          children = _props.children,
          download = _props.download,
          rel = _props.rel,
          target = _props.target,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave;


      var props = _extends({
        download: download,
        href: link
      }, disabled ? {} : { onClick: this._handleOnClick }, {
        role: 'link',
        style: {
          textDecoration: 'inherit',
          color: this.props.color ? this.props.color : 'inherit',
          tabIndex: 0,
          display: 'inline-block'
        }
      });

      if (ariaLabel) {
        props['aria-label'] = ariaLabel;
      }

      if (rel) {
        props.rel = rel;
      }

      if (target) {
        props.target = target;
      }

      if (onMouseEnter) {
        props.onMouseEnter = onMouseEnter;
      }

      if (onMouseLeave) {
        props.onMouseLeave = onMouseLeave;
      }

      return _react2.default.createElement(
        'a',
        props,
        _react2.default.createElement(
          _TextLinkLayout2.default,
          this.props,
          children
        )
      );
    }
  }]);

  return BaseTextLink;
}(_WixComponent3.default);

BaseTextLink.propTypes = _extends({}, _TextLinkLayout2.default.propTypes, {
  link: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  download: _propTypes2.default.bool,
  rel: _propTypes2.default.string,
  target: _propTypes2.default.string,
  ariaLabel: _propTypes2.default.string,
  color: _propTypes2.default.string,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onClick: _propTypes2.default.func
});
BaseTextLink.defaultProps = _extends({}, _TextLinkLayout2.default.defaultProps, {
  disabled: false,
  download: false,
  rel: null,
  target: null,
  onClick: function onClick() {}
});
exports.default = BaseTextLink;